import { mutations as TYPES } from './types';
import { State } from './state';

const mutations = {
  /**
   * Reset
   * @param state State
   */
  [TYPES.RESET](state: State) {
    state = new State();
  },

  [TYPES.TOGGLE_OVERLAY](state: State, value: boolean) {
    state.overlay = value;
  },
  [TYPES.ALERT](state: State, option: any) {
    state.alert = option;
  },
};

export default mutations;
